/* eslint-disable no-unused-vars */
import React from 'react';
import {
  colors, weight, spaces, Div, FlexCenter,
} from 'globalStyle';
import { Hollow } from 'components/Buttons';
import { Text } from 'components/Texts';
import styled, { keyframes } from 'styled-components';
import { Countdown } from 'components/Countdown';

const renderer = ({
  days, hours, minutes, seconds, completed,
}) => {
  if (completed) {
    return (
      <Box>
        <Value>0</Value>
        <Value>0</Value>
        <Value>0</Value>
        <Value>0</Value>
      </Box>
    );
  }
  return (
    <Box>
      <Value>{days}</Value>
      <Value>{hours}</Value>
      <Value>{minutes}</Value>
      <Value>{seconds}</Value>
    </Box>
  );
};

export const Card3 = ({
  projectName,
  closureDate,
  shortDescription,
  category,
  images,
}) => {
  const imagen = images[0];
  return (
    <Body>
      <ImgContainer>
        <Categorie>
          <Text color="#000000" weight="bold" isUpper size={7}>{category}</Text>
        </Categorie>
        <Img
          src={imagen}
          alt={projectName}
        />
      </ImgContainer>
      <ContainerText>
        <Text weight="600" size={14} isCenter mb={10}>
          {projectName}
        </Text>
        <Text size={12} isCenter mb={20}>
          {shortDescription}
        </Text>

        <Date>
          <Countdown
            date={closureDate}
            renderer={renderer}
          />
          <Labels>
            <Name>Días</Name>
            <Name>Horas</Name>
            <Name>Min</Name>
            <Name>Seg</Name>
          </Labels>
        </Date>
        <Div isCenter>
          <Hollow medium>
            <Text size={12}>Recuerdamelo</Text>
          </Hollow>
        </Div>
      </ContainerText>
    </Body>
  );
};

const moveUp = keyframes`
    from {
        height: 0px;
        padding-top: 0px;
    }

    to {
        height: 200px;
        padding-top: 20px;
    }
`;

export const NextRelease = styled.div`
    ${spaces}
    color: ${colors.tertiary};
    font-weight: ${weight.BOLD};
    text-transform: uppercase;
    display: none;
`;

export const Description = styled.div`
    overflow: hidden;
    ${spaces}
    display: none;
    height: 200px;
    padding-top: 20px;
    animation: ${moveUp} .4s ease-in;
    
`;

export const Content = styled.div`
    ${spaces}
    width: 95%;
    margin: 0 auto;
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    padding: 1em;
    background-color: ${colors.WHITE};
    border-radius: 11px;
`;

export const Body = styled.div`
    border-radius: 11px;
    width: 100%;
    border: 1px solid #606060;
    
    &:hover{

      cursor: pointer;
    

        div${Description}, div${NextRelease}{
            display: block;
        }
    }
    overflow: hidden;
`;
export const ImgContainer = styled.div`
  height: 50%;
  overflow: hidden;
`;
export const Img = styled.img`
  object-fit: contain;
  object-position: center;
  width: 100%;
`;
export const Button = styled.button`
  background-color: none;
  border-radius: 26px;
  padding: 9px 19px;
  cursor: pointer;
  font-family: "Monserrate";
  color: #606060;
  trans
  &:hover{
    background-color: #41B7BF;
  }
`;
export const Bot = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 22px;
  margin-bottom: 29px;
  align-items: center;
`;
export const BotText = styled.div`
  display:flex;
  justify-content: space-around;
  align-items: center;
  width: 60px;
`;
export const ContainerText = styled.div`
  height: 50%;
  padding: 17px 0;
`;

export const BackgroundColor = styled.div`
    background-color: rgba(0,0,0,0.10);
    height: 100%;
    width: 100%;
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
`;

export const Grid = styled.div`
    ${spaces}
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 0px 14px;
`;

export const TagNextRelease = styled.div`
    position: absolute;
    top: 15px;
    left: 10px;
    z-index: 1;
    ${spaces}
    font-size: 12px;
    font-weight: ${weight.BOLD};
    border-radius: 12px;
    background-color: ${colors.tertiary};
    color: ${colors.WHITE};
    padding: .3em .6em;
`;

export const FeaturedProjectTag = styled.div`
    position: absolute;
    font-weight: ${weight.BOLD};
    color: ${colors.GRAY_1};
    top: 15px;
    left: -10px;
    background-color: ${colors.secondary};
    padding: .5em 2em;
    text-transform: uppercase;
`;

export const FeaturedProjectCategory = styled.div`
    font-size: 12px;
    font-weight: ${weight.BOLD};
    border-radius: 15px;
    display: inline-block;
    border: 2px solid ${colors.secondary};
    color: ${colors.secondary};
    padding: 1em;
    z-index: 5;
`;

export const Categorie = styled.div`
  border-radius: 25px;
  border: 2px solid #FFCD5C;
  background: #FFCD5C;
  padding: 3px 6px;
  position: absolute;
  z-index: 1;
  right: 20px;
  margin-top: 16px;
  margin-right: 7px;
`;

export const Box = styled.div`
    ${FlexCenter}
    align-items: stretch;
    justify-content: flex-start;
    width: 286px;
    height: 66px;
    margin-bottom: 6px;
    border-radius: 8px;
    border: 1px solid ${colors.GRAY_1};
`;
export const Value = styled.div`
    ${FlexCenter}
    font-weight: ${weight.SEMI_BOLD};
    font-size: 18px;
    color: ${colors.GRAY_1};
    flex: 1;
    text-transform: uppercase;
    border-right: 1px solid ${colors.GRAY_1};

    &:last-child{
        border-right: none;
    }
`;

export const Date = styled.div`
    ${FlexCenter}
    flex-direction: column;
    margin-bottom: 20px;
`;

export const Labels = styled.div`
    ${FlexCenter}
    justify-content: space-around;
    width: 286px;
`;
export const Name = styled.span`
    font-weight: ${weight.SEMI_BOLD};
    font-size: 16px;
    color: ${colors.GRAY_1};
    text-transform: uppercase;
`;
